import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";
import { DocumentEntityService } from "../services/document-entity-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { AclService } from "../services/acl-service";
import { SearchService } from "../services/search-service";

export function RLDocumentFolderHierarchy() {
	var directive: ng.IDirective = {
		restrict: "E",
		bindToController: true,
		template: require("/assets/app/templates/document-folder-hierarchy.html"),
		scope: {
			locked: "=?",
			parentEntityID: '=?parentEntityId',
			parentOpen: "=",
			refreshHierarchy: "=",
			moduleParentEntityID: '=moduleParentEntityId',
			customColumns: '=?',
			availableColumns: "=?"
		},
		controller: RLDocumentFolderHierarchyController,
		controllerAs: "dfhVM"
	};
	return directive;
}

class RLDocumentFolderHierarchyController {
	static $inject = [
		"$scope", "$sce", "$q", "$window", "documentEntityService", "notifyService", "eventService", "entityService",
		"aclService", "searchService"
	];
	folderEntityID: string;
	parentEntityID: string;
	locked: boolean;
	folderList: Models.IEntityCharDataPair[];
	entityHierarchy: Models.IEntityHierarchy;
	entityRoot: Models.IEntitySearchDoc;
	totalDescendants: number;
	parentOpen: boolean;
	loading: boolean;
	refreshHierarchy: boolean;
	refreshHierarchyEntityID: string;
	moduleParentEntityID: string;
	customColumns: Models.ICustomUserColumns;
	itemCustomColumns: Models.ICustomUserColumns;
	availableColumns: Models.IListTableColumn[];
	contactTitles: _.Dictionary<string>; 
	openFolders: _.Dictionary<boolean>;
	loadedHierarchy: Models.IEntityHierarchy[] = [];

	constructor($scope: ng.IScope,
		private $sce: ng.ISCEService,
		private $q: ng.IQService,
		private $window: ng.IWindowService,
		private documentEntityService: DocumentEntityService,
		private notifyService: NotifyService,
		private eventService: EventService,
		private entityService: EntityService,
		private aclService: AclService,
		private searchService: SearchService) {

		this.loading = true;
		this.totalDescendants = 0;	
		this.openFolders = {};

		$scope.$watch(() => this.refreshHierarchy,
			(newValue, oldValue) => {
				if (newValue && newValue !== oldValue) {
					this.RefreshDocuments(this.parentEntityID);
				}
            });
        
        eventService.on(Consts.Events.DocumentGenerated, () => {
            if (Utils.IdBuilder.splitEntityID(this.parentEntityID).charTypeID == Consts.CharTypeIDs.transaction) {
                return this.Init(this.parentEntityID);
            }
        });

		$scope.$watch(() => this.customColumns,
			(newValue) => {
				this.itemCustomColumns = _.cloneDeep(this.customColumns);
			});

		$scope.$watch(() => this.parentEntityID,
			(newValue) => {
				this.Init(newValue);
			});
	}

	Init(entityID: string) {
		if (!_.isEmpty(entityID)) {
			this.RefreshDocuments(entityID);
		}
	}
		
	RefreshDocuments(entityID: string) {
		this.notifyService.startProgress();
		var promises = [];
		var docCreatedByList: number[] = [];
		this.loading = true;

		promises.push(this.searchService.getEntityHierarchy(entityID, Consts.CharTypeIDs.document, 1)
			.then((results) => {
				if (results.success) {
					this.entityHierarchy = results.data;
					docCreatedByList = _.unique(this.entityHierarchy.children.map(c => c.root.lastUpdatedBy));					
					if (this.entityHierarchy.root.entityID == this.parentEntityID) {
						this.entityRoot = this.entityHierarchy.root;
					}
				}
			}));

		promises.push(this.searchService.getChildHierarchyCount(entityID)
			.then((result) => {
				this.totalDescendants = result.data;
			}));

		this.$q.all(promises).then(() => {
			if (docCreatedByList.length > 0) {
				this.getContactTitles(docCreatedByList)
					.then(() => {
						this.loading = false;
						this.notifyService.endProgress();
					});				
			}
			else {
				this.loading = false;
				this.notifyService.endProgress();
			}			
		});
	}

	getContactTitles(contctRecIDs: number[]) {
		this.notifyService.startProgress();
		this.contactTitles = {};
		var request: Models.ISearchResultByRecordIDsRequest = {
			charTypeID: Consts.CharTypeIDs.user,
			recordIDs: contctRecIDs.join(",")
		}
		return this.entityService.getRecordDocumentsForRecordIDs(request)
			.then((result) => {
				_.forEach(result.documents, (recordDocument) => {
					this.contactTitles[recordDocument.recordID] = recordDocument.title;
				});
				this.notifyService.endProgress();
			});
	}
}